import { fork } from 'redux-saga/effects';
import apidocs from './apidocs';
import configuration from './configuration';
import connectors from './connectors';
import components from './components';
import credentials from './credentials';
import flows from './flows';
import models from './models';
import navigation from './navigation';
import restart from '../widgets/Restart';
import schema from './schema';
import summary from './summary';
import system from './system';
import triggers from './triggers';
import updates from './updates';

if (module.hot) {
	module.hot.accept();
}

export default function *root() {
	yield fork(summary.sagas);
	yield fork(apidocs.sagas);
	yield fork(connectors.sagas);
	yield fork(components.sagas);
	yield fork(configuration.sagas);
	yield fork(credentials.sagas);
	yield fork(flows.sagas);
	yield fork(models.sagas);
	yield fork(navigation.sagas);
	yield fork(restart.sagas);
	yield fork(schema.sagas);
	yield fork(system.sagas);
	yield fork(triggers.sagas);
	yield fork(updates.sagas);
}
